export function gallerySlider() {
    let gallery = $('.lookbook-video-list.gallery');
    if (gallery.length) {
        gallery.on('click', '.wp-pagenavi a', function (e) {
            e.preventDefault();

            let _this = $(this);
            let ajax_url = ajax_params.ajaxurl;
            let data = {
                'action': 'paginationGallery',
                'perpage': gallery.attr('data-per-page'),
                'paged': _this.data('paged')
            };

            $.ajax({
                type: "POST",
                url: ajax_url,
                data: data,
                success: function (response) {
                    if (response) {
                        let $holder = $('.holder-ajax-container');
                        let content = $(response);
                        content.css({'opacity': 0});
                        $holder.html(content);
                        content.animate({'opacity': 1}, 300);

                        $("html, body").animate({scrollTop: $('.tab-nav.gallery').offset().top - $('.header').innerHeight() * 1.5}, 500);
                    }
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/gallery-slider.js